import React from "react";
import ReactDOM from "react-dom/client"; // Ensure this is correct
import App from "./Home";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
